export default {
  value: {
    type: [Array, String],
    default: () => [],
  },
  // detail:详情 add:添加 select:选择
  serialNumberType: {
    type: String,
    default: 'select',
  },
  //设置为false，组件不可用
  btnDisabled: {
    type: Boolean,
    default: true,
  },
  // 侧滑或者弹出窗名称
  modelTitle: {
    type: String,
    default: '',
  },
  //serialNumberType=select时， 得数据url
  modelTableDataUrl: {
    type: String,
    default: '',
  },
  //侧滑或者弹出窗种表格得列定义
  modelTableDefUrl: {
    type: String,
    default: '',
  },
  //当前药械名称，用于侧滑或者弹出窗名称显示
  medicalName: {
    type: String,
    default: '-',
  },
  //serialNumberType=select时，请求接口得参数
  chooseRequestParam: {
    type: [String, Object],
    default: () => {},
  },
  //序列号变量名
  serialNumberParamName: {
    type: String,
    default: 'serial',
  },
  //为组件扩展添加得参数（passport使用）
  isShowSelectModelFoot: {
    type: Boolean,
    default: false,
  },
  multiple: {
    type: Boolean,
    default: true,
  },
}
